const { findDetailTaskById } = require("tasks/api")

const findDetailTaskByReference = id => {
    return findDetailTaskById(id).then(data => data.data())
}

export default findDetailTaskByReference